const widthRegex = /(\d+)px/;

/**
 * Zwraca odległość od lewej strony początku tabeli, którą powinna mieć kolumna
 *
 * @export
 * @param {HTMLElement} element
 * @returns {number}
 */
export function getColumnOffset(element: HTMLElement): number {
  let offset = 0;
  let previousSibling = element.previousElementSibling as HTMLElement;
  while (previousSibling) {
    const cssWidth = previousSibling.style?.width && widthRegex.exec(previousSibling.style.width);
    const width = cssWidth ? parseInt(cssWidth[1]) : Math.floor(previousSibling.getBoundingClientRect().width);
    offset += width;
    previousSibling = previousSibling.previousElementSibling as HTMLElement;
  }
  return offset;
}
